import React, { useCallback} from 'react'

import { GAME_FACT_BASKET_STOP, GAME_FACT_RUGBY_STOP, GAME_FACT_SOCCER_STOP, GAME_FACT_START, GAME_FACT_HANDBALL_STOP } from '../gameFact/constants.js'
import { updateMatch } from '../../../actions/matchs.js'
import { Button } from '@mui/material'
import { useDispatch } from 'react-redux'
import { getAllMatchPeriods, getPeriodByType } from '../sports/rules.js'


export const usePeriodButton = ({match, timerValue, enterGameFact, goToGameFact, saveGameFact, stopPeriod, startPeriod}) => {

    const dispatch = useDispatch()

    const getColorControleur = useCallback(() => {
        return match.statusTimer === 'on' || match.timer !== 0? 'success' : 'error'
    }, [match.statusTimer, match.timer])



    function getHandballPeriodButton(match) {

        if(match.status === 'end')
        return;

        let title, textButton, isStart;
        let onClickParam;

        let allPeriods = getAllMatchPeriods(match.discipline);

        let matchPeriod = allPeriods.get(match.period);
        let nextPeriod = allPeriods.get(match.period+1);

        //définir si la prochaine période est jouable ou non, pour définir si on créé un GF ou non au clic du bouton "next"
        if (!nextPeriod){
            isStart = false;
        }else{
            isStart = matchPeriod && nextPeriod.isPlayable;
        }

        title = isStart ? 'Début ' + nextPeriod.name : 'Fin ' +  matchPeriod.name;
        textButton = isStart ? 'Début ' + nextPeriod.name : 'Fin ' +  matchPeriod.name;


            if (isStart){

                onClickParam = () => {
                    goToGameFact(); 
                    enterGameFact(GAME_FACT_START, {timer : 0, period : match.period, comment : '', title}, () => {
                        startPeriod(match.period+1, (...params) => dispatch(updateMatch(...params, undefined, true)))
                    })
                }


            }else{

                onClickParam = () => {
                    
                    goToGameFact(); 

                    enterGameFact(GAME_FACT_HANDBALL_STOP, {comment : '', title, timer : Math.floor(timerValue / 60)+1, period : match.period}, (details) => {
                        //todo getPeriodByType end && next
                        if(details.reason === 'end'){
                            const entries = Array.from(allPeriods.entries());
                            let lastPeriodIndex = entries.length - 1; // Get the last entry
                            stopPeriod(lastPeriodIndex, (idMatch, match) => dispatch(updateMatch(idMatch, {...match, status : 'end'})))
                        } else if(details.reason === 'next'){
                            // Move to the next period
                            let targetPeriod = match.period+1;
                            stopPeriod(targetPeriod, (...params) => dispatch(updateMatch(...params)))
                        } else if (details.reason) {
                           let type = details.reason;
                           let nextPeriod = getPeriodByType(type, match.discipline);

                           if(details.reason==='so'){
                                stopPeriod(nextPeriod.matchPeriod-1, (...params) => dispatch(updateMatch(...params)))
                                const nextGFTitle = 'Début ' + nextPeriod.name;
                                //saveGameFact({id : GAME_FACT_START}, undefined, {comment : '', title : 'Début ' + nextPeriod.name, timer : 0, period : nextPeriod.matchPeriod})
                                enterGameFact(GAME_FACT_START, {timer : 0, period : nextPeriod.matchPeriod, comment : '', title:nextGFTitle }, () => {
                                    startPeriod(nextPeriod.matchPeriod, (...params) => dispatch(updateMatch(...params, undefined, true)))
                                })
                            }else{
                                stopPeriod(nextPeriod.matchPeriod-1, (...params) => dispatch(updateMatch(...params)))
                            }

                        }
                    })
                
                };
                
            }
           
    
        return { title, textButton, onClickParam};
    }


    const getPeriodButton = useCallback(() => {

        let textButton = ""
        let title = ""
        let onClickParam = () => {}

        switch(match.discipline){
            case 'rugby':
            case 'soccer':
                // LE match est fini
                if(match.status==='end' || ((match.period === 2 || match.period === 6) && match.timer === 0 && match.statusTimer==='off'))
                    return


                const REAL_GAME_FACT_STOP = match.discipline === 'soccer' ? GAME_FACT_SOCCER_STOP : GAME_FACT_RUGBY_STOP

                if(match.statusTimer==='on' || match.timer !== 0 || match.period === 5){
                    switch(match.period){
                        case 0 :
                            title = 'Fin de la 1ère période'
                            textButton = 'Fin de la première période'
                            break;
                        case 1 :
                            title = 'Fin de la 2ème période'
                            textButton = 'Fin de la deuxième période'
                            break;
                        case 3 :
                            title = 'Fin de la 1ère prolongation'
                            textButton = 'Fin de la première prolongation'
                            break;
                        case 4 :
                            title = 'Fin de la 2ème prolongation'
                            textButton = 'Fin de la deuxième prolongation'
                            break;
                        case 5 :
                            title = 'Fin de la séance de tirs au but'
                            textButton = 'Fin des tirs au but'
                            break;
                    }

                    onClickParam = () => {
                        goToGameFact();
                        enterGameFact(REAL_GAME_FACT_STOP, {comment : '', title, timer : Math.floor(timerValue / 60)+1, period : match.period}, (details) => {
                            if(details.reason==='end'){
                                let targetPeriod = match.period <= 2 ? 2 : 6
                                stopPeriod(targetPeriod, (idMatch, match) => dispatch(updateMatch(idMatch, {...match, status : 'end'})))
                            } else if(details.reason==='next'){
                                let targetPeriod = match.period === 1 ? 3 : match.period+1
                                stopPeriod(targetPeriod, (...params) => dispatch(updateMatch(...params)))
                            } else if(details.reason==='tab'){
                                let targetPeriod = 5
                                stopPeriod(targetPeriod, (...params) => dispatch(updateMatch(...params)))
                                saveGameFact({id : GAME_FACT_START}, undefined, {comment : '', title : 'Début de la séance de tirs au but', timer : 0, period : 5}); 
                            }
                        })
                    }
                }else if(match.timer === 0 && match.statusTimer==='off'){
                    switch(match.period){
                        case 0 :
                            title = 'Début du match'
                            textButton = 'Démarrer le match'
                            break;
                        case 1 :
                            title = 'Début de la 2e mi-temps'
                            textButton = 'Démarrer la deuxième période'
                            break;
                        case 3 :
                            title = 'Début de la 1ère prolongation'
                            textButton = 'Démarrer la première prolongation'
                            break;
                        case 4 :
                            title = 'Début de la 2ème prolongation'
                            textButton = 'Démarrer la deuxième prolongation'
                            break;
                    }

                    onClickParam = () => {
                        goToGameFact();
                        enterGameFact(GAME_FACT_START, {timer : 0, period : match.period, comment : '', title}, () => {
                            startPeriod(match.period, (...params) => dispatch(updateMatch(...params, undefined, true)))
                        })}
                }

                return <Button onClick={onClickParam} sx={{fontSize : '0.8em'}} color={getColorControleur()} variant="contained">{textButton}</Button>
            
            case 'basket' : 
                if(match.status==='end')
                    return
                
                if(match.statusTimer==='on' || match.timer !== 0){
                    title = 'Fin du '+ (parseInt(match.period) + 1) +'e quart temps'
                    textButton = 'Fin du '+ (parseInt(match.period) + 1) +'e quart temps'

                    onClickParam = () => {
                        goToGameFact();
                        enterGameFact(GAME_FACT_BASKET_STOP, {comment : '', title, timer : Math.floor(timerValue / 60)+1, period : match.period}, (details) => {
                            if(details.reason==='end'){
                                let targetPeriod = match.period+1
                                stopPeriod(targetPeriod, (idMatch, match) => dispatch(updateMatch(idMatch, {...match, status : 'end'})))
                            }else{
                                let targetPeriod = match.period+1
                                stopPeriod(targetPeriod, (...params) => dispatch(updateMatch(...params)))
                            }
                            
                        })
                    }
                }else if(match.timer === 0 && match.statusTimer==='off'){
                    title = 'Début du '+ (parseInt(match.period) + 1) +'e quart temps'
                    textButton = 'Début du '+ (parseInt(match.period) + 1) +'e quart temps'

                    onClickParam = () => {
                        goToGameFact();
                        enterGameFact(GAME_FACT_START, {timer : 0, period : match.period, comment : '', title}, () => {
                            startPeriod(match.period, (...params) => dispatch(updateMatch(...params, undefined, true)))
                        })}
                }
                return <Button onClick={onClickParam} sx={{fontSize : '0.8em'}} color={getColorControleur()} variant="contained">{textButton}</Button>

            case 'handball':
                const handballPeriodParams = getHandballPeriodButton(match);
                if (handballPeriodParams) {
                   return <Button onClick={handballPeriodParams.onClickParam} sx={{fontSize : '0.8em'}} color={getColorControleur()} variant="contained">{handballPeriodParams.textButton}</Button>
                }
                return;
            
            default : 
                return <Button onClick={onClickParam} sx={{fontSize : '0.8em'}} color={getColorControleur()} variant="contained">{textButton}</Button>
            }

    }, [,match.timer, match.period, match.statusTimer, timerValue, match.discipline, match.status])

    return getPeriodButton
}

